module.exports = __webpack_public_path__ + "img/4inBox_I_small2-min.e87a85aa.png";